<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :title="evaluationIndex.title"
      :id="evaluationIndex.id"
      :close="closeOneSelf"
      v-if="cross_group_type == 'global'"
    >
      <template slot="content">
        <el-form
          ref="form"
          label-position="left"
          class="settings"
          label-width="110px"
        >
          <el-form-item>
            <el-select
              v-model="value"
              placeholder="请选择"
              @change="changeData"
            >
              <el-option
                v-for="item in sectionList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="一般对象数："
            v-if="cross_group_type == 'global'"
          >
            <span class="valueStyle">{{
              sectionList[index].illustrate ? sectionList[index].objectCount : 0
            }}</span>
          </el-form-item>
          <el-form-item
            label="工点对象数："
            v-if="cross_group_type == 'global'"
          >
            <span class="valueStyle">{{
              sectionList[index].illustrate
                ? sectionList[index].workPntCount
                : 0
            }}</span>
          </el-form-item>
          <el-form-item
            label="区段长度(km)："
            v-if="cross_group_type == 'global'"
          >
            <span class="valueStyle">{{
              sectionList[index].illustrate
                ? sectionList[index].sectionLength
                : 0
            }}</span>
          </el-form-item>
          <el-form-item label="通行能力：" v-if="cross_group_type == 'working'">
            <span class="valueStyle">{{
              sectionList[index].passAbility
                ? sectionList[index].passAbility
                : 0
            }}</span>
          </el-form-item>
          <el-form-item label="安全系数：" v-if="cross_group_type == 'working'">
            <span class="valueStyle">{{
              sectionList[index].safeNum ? sectionList[index].safeNum : 0
            }}</span>
          </el-form-item>
          <el-form-item label="开始时间：" v-if="cross_group_type == 'working'">
            <span class="valueStyle">{{
              sectionList[index].startTime ? sectionList[index].startTime : "无"
            }}</span>
          </el-form-item>
          <el-form-item label="结束时间：" v-if="cross_group_type == 'working'">
            <span class="valueStyle">{{
              sectionList[index].endTime ? sectionList[index].endTime : "无"
            }}</span>
          </el-form-item>
          <el-form-item label="说明：" v-if="cross_group_type == 'working'">
            <span class="valueStyle">{{
              sectionList[index].illustrate
                ? sectionList[index].illustrate
                : "无"
            }}</span>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>
    <BaotongScheme v-if="cross_group_type == 'working'"></BaotongScheme>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const BaotongScheme = () =>
  import("@/components/tables/BaotongScheme/BaotongScheme");
import {
  BimSimConstructSectionsDetail,
  bimSimWorkingDescDetail,
} from "@/api/api";

export default {
  components: {
    MapModal,
    BaotongScheme,
  },
  data() {
    return {
      evaluationIndex: {
        title: "区段信息",
        id: "evaluationIndex",
      },
      modalNode: {
        evaluationIndex: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            left: 252,
          },
          // width: "450px", // 宽度配置 默认450px
          height: "250px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      value: "",
      index: 0,
      sectionList: [[]],
      cross_group_type: window.sessionStorage.getItem("cross_group_type"),
    };
  },
  methods: {
    getData() {
      // bimSimWorkingDescDetail
      console.log(window.sessionStorage.getItem("crossGroupSimId"));
      console.log(this.$store.state.simId);
      console.log(this.cross_group_type, "cross_group_type");
      // if (this.$store.state.simId) {
      //   BimSimConstructSectionsDetail({
      //     SimId: this.$store.state.simId,
      //     SectionNum: 0,
      //   }).then((res) => {
      //     this.sectionList = res.data.data;
      //     if (this.sectionList.length) {
      //       this.value = this.sectionList[0].id;
      //       console.log(this.cross_group_type, "cross_group_type");
      //     }
      //   });
      // } else {
      //   this.$message({
      //     message: "请先将时间轴拖动在阶段上！",
      //     type: "warning",
      //     duration: 1000,
      //   });
      //   this.closeOneSelf();
      // }
      if (this.cross_group_type == "working") {
        bimSimWorkingDescDetail({
          SimId: window.sessionStorage.getItem("crossGroupSimId"),
          SectionNum: 0,
        }).then((res) => {
          this.sectionList = res.data.data;
          if (this.sectionList.length) {
            this.sectionList.forEach((el) => {
              el.name = el.stageName;
            });
            this.value = this.sectionList[0].id;
          }
        });
      } else {
        BimSimConstructSectionsDetail({
          SimId: window.sessionStorage.getItem("crossGroupSimId"),
          SectionNum: 0,
        }).then((res) => {
          this.sectionList = res.data.data;
          if (this.sectionList.length) {
            this.value = this.sectionList[0].id;
            console.log(this.cross_group_type, "cross_group_type");
          }
        });
      }
    },
    changeData(data) {
      console.log(data);
      this.sectionList.forEach((el, i) => {
        if (el.id == data) {
          this.index = i;
        }
      });
    },
    closeOneSelf() {
      this.$emit("sectionInformationShow");
    },
  },
  created() {
    if (this.cross_group_type == "working") {
      this.$store.commit("sendStage", {
        arr: "阶段1",
        SimId: window.sessionStorage.getItem("crossGroupSimId"),
      });
    } else {
      this.getData();
    }
  },
  mounted() {
    if (window.sessionStorage.getItem("cross_group_type") == "working") {
      this.modalNode.evaluationIndex.height = "350px";
    } else {
      this.modalNode.evaluationIndex.height = "185px";
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form.settings {
  width: 100%;
  @include hvcenter(column);
  // padding: 8px 0 0 0;
  padding: 8px 0 14px 0;
  .el-form-item {
    width: 100%;
    padding: 0 0 0 7px;
    // display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 18px;
    .el-form-item__label {
      margin-bottom: 0px;
      font-size: 12px;
      @include font_color("t_color_op1");
      padding: 0;
      flex-grow: 0;
      line-height: 32px;
      padding-right: 10px;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      line-height: 32px;
      .el-select {
        @include select_base();
      }
      .el-autocomplete {
        @include select_base();
      }
      .el-input {
        @include input_base();
      }
      .el-textarea {
        @include textarea_base();
      }
      .el-checkbox {
        @include checkbox_base();
      }
    }
    .showInline {
      margin: 10px 6px;
      width: 96px;
      display: inline-block;
      text-align: right;
      @include lheight(26);
      font-size: 11px;
      @include font_color("t_color_op1");
      .el-input-number {
        margin-left: -5px !important;
        @include input_number();
      }
      .el-input-number__increase {
        height: 32px;
        line-height: 32px;
      }
      .el-input__inner {
        width: 100% !important;
      }
    }
    &:first-child {
      padding: 10px 0 0 7px;
    }
    &.description {
      margin-bottom: 12px;
    }

    &.btns {
      margin-bottom: 12px;
      .el-form-item__content {
        width: 166px;
        @include button_primary();
        @include button_default();
      }
    }
  }
}

/deep/.el-form-item {
  margin-bottom: 0px !important;
}
.valueStyle {
  color: rgba(255, 255, 255, 0.9);
  padding-right: 10px;
}
/deep/.el-input__inner {
  color: rgba(255, 255, 255, 0.9);
}
</style>
